export const isDateLikeValue = (value: unknown): value is Date | string => {
  if (typeof value !== 'string' && !(value instanceof Date)) {
    return false
  }

  return !Number.isNaN(new Date(value).getTime())
}

const toTimestamp = (value: Date | string): number =>
  value instanceof Date ? value.getTime() : new Date(value).getTime()

export const areDatesEqual = (left: unknown, right: unknown): boolean => {
  const leftIsDate = isDateLikeValue(left)
  const rightIsDate = isDateLikeValue(right)

  if (!leftIsDate || !rightIsDate) {
    return false
  }

  return toTimestamp(left) === toTimestamp(right)
}
